import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, isValid, parseISO } from "date-fns";
import { useState } from "react";

import Svg from "../../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../../ui library/HNSColors";
import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

export function DateAnswer({ name, label, value = "", onChange, placeholder }) {
  const [isFocused, setIsFocused] = useState(false);

  const toDate = (rawValue) => {
    if (!rawValue) {
      return null;
    }

    if (rawValue instanceof Date) {
      return isValid(rawValue) ? rawValue : null;
    }

    if (typeof rawValue === "string") {
      const trimmed = rawValue.trim();
      if (!trimmed) {
        return null;
      }

      const isoDate = parseISO(trimmed);
      if (isValid(isoDate)) {
        return isoDate;
      }

      const parsed = new Date(trimmed);
      return isValid(parsed) ? parsed : null;
    }

    // fallback for timestamp-like numbers
    if (typeof rawValue === "number") {
      const parsed = new Date(rawValue);
      return isValid(parsed) ? parsed : null;
    }

    return null;
  };

  const handleChange = (newDate) => {
    if (!newDate) {
      onChange(name, "");
      return;
    }

    const normalized =
      newDate instanceof Date
        ? newDate
        : new Date(
            typeof newDate === "number" || typeof newDate === "string"
              ? newDate
              : newDate?.getTime?.()
          );

    if (!normalized || !isValid(normalized)) {
      onChange(name, "");
      return;
    }

    onChange(name, format(normalized, "yyyy-MM-dd"));
  };

  return (
    <Box mb={2}>
      <QuestionTitle label={label} sx={sharedStyles.label(isFocused)} />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          className="w-full text-center"
          format="MM/dd/yyyy"
          value={toDate(value)}
          onChange={handleChange}
          onOpen={() => setIsFocused(true)}
          onClose={() => setIsFocused(false)}
          slots={{
            openPickerIcon: CalendarIcon,
          }}
          slotProps={{
            textField: {
              onFocus: () => setIsFocused(true),
              onBlur: () => setIsFocused(false),
              sx: sharedStyles.dateTimePicker.textField,
              placeholder,
            },
            openPickerButton: {
              disableRipple: true,
              sx: sharedStyles.dateTimePicker.openPickerButton,
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
}

const CalendarIcon = (props) => (
  <Svg {...props} name="his-calendar" color={HNSColors.primary[500]} sx={{ ...props.sx }} />
);

export default DateAnswer;
